import React, { useEffect, useState } from 'react';
const iconHowItWorks = require('../assets/icons-pack/ic_howitworks.png')
const iconSales = require('../assets/icons-pack/ic_contactsales.png')
const iconWhatsNew = require('../assets/icons-pack/ic_whatsnew.png')
const iconWhyDetasad = require('../assets/icons-pack/ic_whydetasad.png')

function Cards() {
    const [mobile,setMobile] = useState(false)
    
    const checkAnd = async () => {
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setMobile({mobile:true})
        }
    }
    
    useEffect(()=>{
        checkAnd();
    },[])

    return (
        <section>
            <div className="container justify-content-center">
                <div className={!mobile?"row padding-cards":"row padding-cards mt-4"}>
                    <div className="col-md-3">
                        <div className={!mobile? "help-card text-left" : "help-card"}>
                            <img src={iconSales} className="d-inline sales-icon" alt="sales icon" />
                            <p className={"help-header ml-2 d-inline "}>Contact Us</p>
                            <p className={ "help-body "}>Send us an email to <a href="mailto:info@detasad.com">info@detasad.com</a> for acquiring information on the services.</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className={!mobile? "help-card text-left" : "help-card"}>
                            <img src={iconHowItWorks} className="d-inline sales-icon" alt="sales icon" />
                            <p className={"help-header ml-2 d-inline "}>Service Trials</p>
                            <p className={ "help-body "}>Evaluate our services before actual spending by using the trial option.</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className={!mobile? "help-card text-left" : "help-card"}>
                            <img src={iconWhatsNew} className="d-inline sales-icon" alt="sales icon" />
                            <p className={"help-header ml-2 d-inline "}>24/7 Support</p>
                            <p className={ "help-body "}>We are available anytime to assist you with your requirements.</p>
                        </div>
                    </div>
                    <div className={!mobile?"col-md-3":"col-md-3 mb-4"}>
                        <div className={!mobile? "help-card text-left" : "help-card"}>
                            <img src={iconWhyDetasad} className="d-inline sales-icon" alt="sales icon" />
                            <p className={"help-header ml-2 d-inline "}>Why DETASAD</p>
                            <p className={ "help-body "}>We are your business partner who understands the whole picture.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Cards;
